// Debug Login Issue - Temporary Fix
// This will help identify the exact problem

import { API_CONFIG, getApiUrl } from "../config/api";

// Simple debug function to test API connectivity
export const debugLogin = async (email, password) => {
  console.log("🔍 Debug Login - Starting...");
  console.log("API Base URL:", API_CONFIG.BASE_URL);
  console.log("Login Endpoint:", API_CONFIG.ENDPOINTS.LOGIN);
  console.log("Full URL:", getApiUrl(API_CONFIG.ENDPOINTS.LOGIN));

  try {
    // Test basic connectivity first
    console.log("🔍 Testing basic connectivity...");
    const testResponse = await fetch(getApiUrl("/api/verify"), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    console.log("🔍 Test response status:", testResponse.status);
    console.log("🔍 Test response headers:", Object.fromEntries(testResponse.headers.entries()));

    // Now test login
    console.log("🔍 Testing login...");
    const loginResponse = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.LOGIN), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    console.log("🔍 Login response status:", loginResponse.status);
    console.log("🔍 Login response headers:", Object.fromEntries(loginResponse.headers.entries()));

    const contentType = loginResponse.headers.get("content-type");
    console.log("🔍 Content type:", contentType);

    if (!contentType || !contentType.includes("application/json")) {
      const textResponse = await loginResponse.text();
      console.error("🔍 Non-JSON response:", textResponse);
      return {
        success: false,
        error: `Server returned non-JSON response: ${textResponse.substring(0, 100)}`,
      };
    }

    const data = await loginResponse.json();
    console.log("🔍 Login response data:", data);

    return data;
  } catch (error) {
    console.error("🔍 Login error:", error);
    return {
      success: false,
      error: `Network error: ${error.message}`,
    };
  }
};

// Fallback simple login function
export const simpleLogin = async (email, password) => {
  try {
    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.LOGIN), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const textResponse = await response.text();
      throw new Error(`Non-JSON response: ${textResponse.substring(0, 100)}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Simple login error:", error);
    return {
      success: false,
      error: error.message || "Login failed",
    };
  }
};
